import { API_ENDPOINT } from "./Api";
import requestInstance from "./Request";
import { setCurrentUser } from "utils/utils";

let env = process.env.REACT_APP_B2B_API_BASE_URL;

export const rateCardApi = async (data) => {
  let url = "";

  const payload = {
    dutyType: data?.type || data?.dutyTypeId,
    carType: data?.carType || data?.vehicleCategoryId,
  };

  if (data?.id) {
    url = `${env}${API_ENDPOINT.RateCard.api}?tripType=${data?.type}&contractId=${data?.id}`;
  } else {
    url = `${env}${API_ENDPOINT.RateCard.api}?&tripType=${payload?.dutyType}&contractId=${data?.contractId}&carType=${payload?.carType}&location=${data?.location}`;
  }

  const res = await requestInstance.get(url).catch((err) => err.response);
  return setCurrentUser(res);
};

export const getCompanyDutyType = async (data) => {
  const payload = {
    vendorId: data?.vendorId,
  };

  const url = `${env}${API_ENDPOINT.RateCard.vendorDuty}?&vendorId=${payload?.vendorId}`;
  const res = await requestInstance.get(url, data).catch((err) => err.response);
  return setCurrentUser(res);
};